/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_Sync_IcalInputs */

const en_seller_calendar_sync_ical = /** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync iCal`)
};

const es_seller_calendar_sync_ical = /** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar iCal`)
};

const fr_seller_calendar_sync_ical = /** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser iCal`)
};

const de_seller_calendar_sync_ical = /** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iCal synchronisieren`)
};

const id_seller_calendar_sync_ical = /** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronisasi iCal`)
};

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const ja_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const zh_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const ar_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const it_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const ru_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const pt_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/** @type {(inputs: Seller_Calendar_Sync_IcalInputs) => LocalizedString} */
const ko_seller_calendar_sync_ical = en_seller_calendar_sync_ical;

/**
* | output |
* | --- |
* | "Sync iCal" |
*
* @param {Seller_Calendar_Sync_IcalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_sync_ical = /** @type {((inputs?: Seller_Calendar_Sync_IcalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_Sync_IcalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_sync_ical(inputs)
	if (locale === "es") return es_seller_calendar_sync_ical(inputs)
	if (locale === "fr") return fr_seller_calendar_sync_ical(inputs)
	if (locale === "de") return de_seller_calendar_sync_ical(inputs)
	if (locale === "ja") return ja_seller_calendar_sync_ical(inputs)
	if (locale === "zh") return zh_seller_calendar_sync_ical(inputs)
	if (locale === "ar") return ar_seller_calendar_sync_ical(inputs)
	if (locale === "id") return id_seller_calendar_sync_ical(inputs)
	if (locale === "it") return it_seller_calendar_sync_ical(inputs)
	if (locale === "ru") return ru_seller_calendar_sync_ical(inputs)
	if (locale === "pt") return pt_seller_calendar_sync_ical(inputs)
	return ko_seller_calendar_sync_ical(inputs)
});